module.exports = __webpack_public_path__ + "static/media/logo.45cc4ce0.png";